import AdminLayout from "components/admin/layout"
import {options} from "shared/sanitized-html"
import PageComponent from "components/page-component"
import React from "react"
import RenderHtml from "shared/render-html"
import setLayout from "shared/set-layout"
import {View} from "react-native-propforge"

export default class RoutesAdminTestsSanitizedHtml extends PageComponent {
  render() {
    setLayout("admin")

    return (
      <AdminLayout className="routes--admin--tests--sanitized-html">
        <View testID="admin-tests-render-html-style-contract">
          <RenderHtml
            source={`
              <p>Styled RenderHtml normal paragraph</p>
              <p
                class="render-html-inline-style-target"
                style="background-color: #ffe600; color: #1a5cff; font-size: 26px; font-weight: 700; text-align: center;"
              >
                Styled RenderHtml paragraph
              </p>
              <p class="ckeditor-heading-4">Styled RenderHtml CKEditor heading</p>
              <p><strong>Styled RenderHtml bold</strong> and <em>Styled RenderHtml italic</em></p>
              <p
                style="border: 2px solid #00a0a0; border-radius: 8px; height: 70px; line-height: 32px; margin: 12px 0; padding: 10px 14px; width: 240px;"
              >
                Styled RenderHtml box paragraph
              </p>
              <p>
                <span style="color: #d13a8f; font-style: italic; letter-spacing: 2px; text-decoration-line: underline;">Styled RenderHtml decorated span</span>
              </p>
              <p>
                <a
                  href="https://example.com/render-html"
                  target="_blank"
                  title="RenderHtml Example"
                  style="color: #008000; text-decoration-line: underline;"
                >Styled RenderHtml link</a>
              </p>
              <ul><li style="color: #663399;">Styled RenderHtml unordered item</li></ul>
              <ol><li style="font-weight: 700;">Styled RenderHtml ordered item</li></ol>
              <blockquote style="border-left-color: #ff8800; border-left-width: 6px; padding-left: 18px;"><p>Styled RenderHtml quote</p></blockquote>
              <table>
                <thead>
                  <tr><th style="background-color: #d9f2ff;">Styled RenderHtml table heading</th></tr>
                </thead>
                <tbody>
                  <tr><td style="padding: 9px;">Styled RenderHtml table cell</td></tr>
                </tbody>
              </table>
              <figure>
                <figcaption>Styled RenderHtml figure caption</figcaption>
              </figure>
            `}
          />
        </View>
        <pre className="white-list">
          {JSON.stringify(options.whiteList, null, 2)}
        </pre>
      </AdminLayout>
    )
  }
}
